import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import './Toast.scss';

function Toast({ message, type = 'error', visible, onClose, duration = 3000 }) {
  useEffect(() => {
    if (visible && duration > 0) {
      const timer = setTimeout(onClose, duration);
      return () => clearTimeout(timer);
    }
  }, [visible, duration, onClose]);

  if (!visible) return null;

  return (
    <div className={`toast toast--${type}`}>
      <span className="toast-msg">{message}</span>
      <button className="toast-close" onClick={onClose}><X size={14} /></button>
    </div>
  );
}

export default Toast;
